<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <form autocomplete="off">
      <div class="my-card">
        <div class="row">
          <CustomSelectBox
            :className="'col-md-12'"
            :id="'establishmentRoleToken'"
            :value="userEstablishmentPrivilegeDate.establishmentRoleToken"
            :options="establishmentRoleTokenOptions"
            v-on:changeValue="changeEstablishmentRoleToken($event)"
            :title="$t('setting.others.establishmentRolesMsgs.select')"
            :imgName="'establishment-roles.svg'"
          />
        </div>
      </div>

      <div v-if="userEstablishmentPrivilegeDate.establishmentRoleToken">
        <UsersPrivilegeEmployees
          :usersPrivilegeEmployees="
            userEstablishmentPrivilegeDate.usersPrivilegeEmployees
          "
        />

        <UsersPrivilegeEmployeesAttendance
          :usersPrivilegeEmployeesAttendance="
            userEstablishmentPrivilegeDate.usersPrivilegeEmployeesAttendance
          "
        />
        <UsersPrivilegeEmployeesMovement
          :usersPrivilegeEmployeesMovement="
            userEstablishmentPrivilegeDate.usersPrivilegeEmployeesMovement
          "
        />
        <UsersPrivilegeEmployeesMovementMedai
          :usersPrivilegeEmployeesMovementMedai="
            userEstablishmentPrivilegeDate.usersPrivilegeEmployeesMovementMedai
          "
        />
        <UsersPrivilegeEmployeesSettlementMovement
          :usersPrivilegeEmployeesSettlementMovement="
            userEstablishmentPrivilegeDate.usersPrivilegeEmployeesSettlementMovement
          "
        />
        <UsersPrivilegeEmployeesMoveSlides
          :usersPrivilegeEmployeesMoveSlides="
            userEstablishmentPrivilegeDate.usersPrivilegeEmployeesMoveSlides
          "
        />

        <!-- <UserPrivillegBranchesSettings
          :userPrivillegBranchesSettings="
            userEstablishmentPrivilegeDate.userPrivillegBranchesSettings
          "
        /> -->

        <!-- <UsersPrivilegeClients
          :usersPrivilegeClients="
            userEstablishmentPrivilegeDate.usersPrivilegeClients
          "
        /> -->
        <!-- <UsersPrivilegeNews
          :usersPrivilegeNews="
            userEstablishmentPrivilegeDate.usersPrivilegeNews
          "
        />
        <UsersPrivilegeOffers
          :usersPrivilegeOffers="
            userEstablishmentPrivilegeDate.usersPrivilegeOffers
          "
        /> -->

        <UsersPrivilegeBranches
          :usersPrivilegeBranches="
            userEstablishmentPrivilegeDate.usersPrivilegeBranches
          "
        />
        <!-- <UsersPrivilegeOfficesTimes
          :usersPrivilegeOfficesTimes="
            userEstablishmentPrivilegeDate.usersPrivilegeOfficesTimes
          "
        /> -->

        <!-- <UsersPrivilegeServicesReservations
          :usersPrivilegeServicesReservations="
            userEstablishmentPrivilegeDate.usersPrivilegeServicesReservations
          "
        />
        <UsersPrivilegeServicesReservationTreatmentPlan
          :usersPrivilegeServicesReservationTreatmentPlan="
            userEstablishmentPrivilegeDate.usersPrivilegeServicesReservationTreatmentPlan
          "
        /> -->

        <UsersPrivilegeTreasuries
          :usersPrivilegeTreasuries="
            userEstablishmentPrivilegeDate.usersPrivilegeTreasuries
          "
        />
        <UsersPrivilegeTreasuriesTransaction
          :usersPrivilegeTreasuriesTransaction="
            userEstablishmentPrivilegeDate.usersPrivilegeTreasuriesTransaction
          "
        />
        <UsersPrivilegeExpenses
          :usersPrivilegeExpenses="
            userEstablishmentPrivilegeDate.usersPrivilegeExpenses
          "
        />
        <UsersPrivilegeRevenus
          :usersPrivilegeRevenus="
            userEstablishmentPrivilegeDate.usersPrivilegeRevenus
          "
        />

        <UsersPrivilegeEmployeeBranches
          :usersPrivilegeEmployeeBranches="
            userEstablishmentPrivilegeDate.usersPrivilegeEmployeeBranches
          "
        />

        <UsersPrivilegeEmployeeOfficialHolidaysPlans
          :usersPrivilegeEmployeeOfficialHolidaysPlans="
            userEstablishmentPrivilegeDate.usersPrivilegeEmployeeOfficialHolidaysPlans
          "
        />
        <UsersPrivilegeEmployeeWorkSchedule
          :usersPrivilegeEmployeeWorkSchedule="
            userEstablishmentPrivilegeDate.usersPrivilegeEmployeeWorkSchedule
          "
        />
        <UsersPrivilegeEmployeeSalarySetting
          :usersPrivilegeEmployeeSalarySetting="
            userEstablishmentPrivilegeDate.usersPrivilegeEmployeeSalarySetting
          "
        />

        <UsersPrivilegAdditionalSettings
          :usersPrivilegAdditionalSettings="
            userEstablishmentPrivilegeDate.usersPrivilegAdditionalSettings
          "
        />
        <UsersPrivilegeEstablishmentsSettings
          :usersPrivilegeEstablishmentsSettings="
            userEstablishmentPrivilegeDate.usersPrivilegeEstablishmentsSettings
          "
        />
        <UsersPrivilegeEstablishmentYearSetting
          :usersPrivilegeEstablishmentYearSetting="
            userEstablishmentPrivilegeDate.usersPrivilegeEstablishmentYearSetting
          "
        />

        <UsersPrivilegeUsers
          :usersPrivilegeUsers="
            userEstablishmentPrivilegeDate.usersPrivilegeUsers
          "
        />

        <div class="form-footer">
          <button
            name="submit"
            type="submit"
            class="btn btn-submit"
            @click.prevent="updateUserEstablishmentPrivilege"
          >
            {{ submitName }}
          </button>
          <router-link to="/employees" class="btn btn-cancel">
            {{ $t("cancel") }}
          </router-link>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import CustomSelectBox from "@/components/general/CustomSelectBox.vue";
import UsersPrivilegeEmployees from "@/components/privileges/establishmentPrivileges/UsersPrivilegeEmployees.vue";
import UsersPrivilegeEmployeesAttendance from "@/components/privileges/establishmentPrivileges/UsersPrivilegeEmployeesAttendance.vue";
import UsersPrivilegeEmployeesMovement from "@/components/privileges/establishmentPrivileges/UsersPrivilegeEmployeesMovement.vue";
import UsersPrivilegeEmployeesMovementMedai from "@/components/privileges/establishmentPrivileges/UsersPrivilegeEmployeesMovementMedai.vue";
import UsersPrivilegeEmployeesSettlementMovement from "@/components/privileges/establishmentPrivileges/UsersPrivilegeEmployeesSettlementMovement.vue";
import UsersPrivilegeEmployeesMoveSlides from "@/components/privileges/establishmentPrivileges/UsersPrivilegeEmployeesMoveSlides.vue";
// import UserPrivillegBranchesSettings from "@/components/privileges/establishmentPrivileges/UserPrivillegBranchesSettings.vue";
import UsersPrivilegeEstablishmentsSettings from "@/components/privileges/establishmentPrivileges/UsersPrivilegeEstablishmentsSettings.vue";
// import UsersPrivilegeClients from "@/components/privileges/establishmentPrivileges/UsersPrivilegeClients.vue";
// import UsersPrivilegeNews from "@/components/privileges/establishmentPrivileges/UsersPrivilegeNews.vue";
// import UsersPrivilegeOffers from "@/components/privileges/establishmentPrivileges/UsersPrivilegeOffers.vue";
import UsersPrivilegeBranches from "@/components/privileges/establishmentPrivileges/UsersPrivilegeBranches.vue";
// import UsersPrivilegeOfficesTimes from "@/components/privileges/establishmentPrivileges/UsersPrivilegeOfficesTimes.vue";
// import UsersPrivilegeServicesReservations from "@/components/privileges/establishmentPrivileges/UsersPrivilegeServicesReservations.vue";
// import UsersPrivilegeServicesReservationTreatmentPlan from "@/components/privileges/establishmentPrivileges/UsersPrivilegeServicesReservationTreatmentPlan.vue";
import UsersPrivilegeTreasuries from "@/components/privileges/establishmentPrivileges/UsersPrivilegeTreasuries.vue";
import UsersPrivilegeTreasuriesTransaction from "@/components/privileges/establishmentPrivileges/UsersPrivilegeTreasuriesTransaction.vue";
import UsersPrivilegeExpenses from "@/components/privileges/establishmentPrivileges/UsersPrivilegeExpenses.vue";
import UsersPrivilegeRevenus from "@/components/privileges/establishmentPrivileges/UsersPrivilegeRevenus.vue";
import UsersPrivilegAdditionalSettings from "@/components/privileges/establishmentPrivileges/UsersPrivilegAdditionalSettings.vue";
import UsersPrivilegeUsers from "@/components/privileges/establishmentPrivileges/UsersPrivilegeUsers.vue";
import UsersPrivilegeEmployeeSalarySetting from "@/components/privileges/establishmentPrivileges/UsersPrivilegeEmployeeSalarySetting.vue";
import UsersPrivilegeEmployeeWorkSchedule from "@/components/privileges/establishmentPrivileges/UsersPrivilegeEmployeeWorkSchedule.vue";
import UsersPrivilegeEmployeeBranches from "@/components/privileges/establishmentPrivileges/UsersPrivilegeEmployeeBranches.vue";
import UsersPrivilegeEmployeeOfficialHolidaysPlans from "@/components/privileges/establishmentPrivileges/UsersPrivilegeEmployeeOfficialHolidaysPlans.vue";
import UsersPrivilegeEstablishmentYearSetting from "@/components/privileges/establishmentPrivileges/UsersPrivilegeEstablishmentYearSetting.vue";
import EstablishmentRole from "@/models/settings/settingsOther/establishmentRoles/EstablishmentRole";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "EstablishmentPrivilegeForm",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    CustomSelectBox,
    UsersPrivilegeEmployees,
    UsersPrivilegeEmployeesAttendance,
    UsersPrivilegeEmployeesMovement,
    UsersPrivilegeEmployeesMovementMedai,
    UsersPrivilegeEmployeesSettlementMovement,
    UsersPrivilegeEmployeesMoveSlides,
    // UserPrivillegBranchesSettings,
    UsersPrivilegeEstablishmentsSettings,
    // UsersPrivilegeClients,
    // UsersPrivilegeNews,
    // UsersPrivilegeOffers,
    UsersPrivilegeBranches,
    // UsersPrivilegeOfficesTimes,
    // UsersPrivilegeServicesReservations,
    // UsersPrivilegeServicesReservationTreatmentPlan,
    UsersPrivilegeTreasuries,
    UsersPrivilegeTreasuriesTransaction,
    UsersPrivilegeExpenses,
    UsersPrivilegeRevenus,
    UsersPrivilegAdditionalSettings,
    UsersPrivilegeUsers,
    UsersPrivilegeEmployeeSalarySetting,
    UsersPrivilegeEmployeeWorkSchedule,
    UsersPrivilegeEmployeeBranches,
    UsersPrivilegeEmployeeOfficialHolidaysPlans,
    UsersPrivilegeEstablishmentYearSetting,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      establishmentRoleData: new EstablishmentRole(),
      establishmentRoleTokenOptions: [],
    };
  },
  props: ["userEstablishmentPrivilegeDate", "submitName"],
  methods: {
    async changeEstablishmentRoleToken(establishmentRoleToken) {
      this.userEstablishmentPrivilegeDate.establishmentRoleToken =
        establishmentRoleToken;
      this.getUserEstablishmentPrivilege();
    },
    async getDialogOfEstablishmentRoles() {
      this.isLoading = true;
      this.establishmentRoleTokenOptions = [];
      this.establishmentRoleTokenOptions.push({
        value: "",
        text: this.$t("setting.others.establishmentRolesMsgs.select"),
      });
      try {
        let response =
          await this.establishmentRoleData.getDialogOfEstablishmentRoles(
            this.language,
            this.userAuthorizeToken
          );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.establishmentRoleTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getUserEstablishmentPrivilege() {
      this.isLoading = true;
      try {
        let response =
          await this.userEstablishmentPrivilegeDate.getUserEstablishmentPrivilege(
            this.language,
            this.userAuthorizeToken
          );
        if (response.data.status == STATUS.SUCCESS) {
          this.userEstablishmentPrivilegeDate.fillData(
            response.data.usersEstablishmentPrivilegeData
          );
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async updateUserEstablishmentPrivilege() {
      this.$emit("updateUserEstablishmentPrivilege");
    },
  },
  async created() {
    this.getDialogOfEstablishmentRoles();
  },
};
</script>

<style scoped lang="scss"></style>
